var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-pagination',{staticClass:"queryView-pagination",attrs:{"total":_vm.total,"current":_vm.current,"pageSize":_vm.pageSize,"showTotal":_vm.showTotalFn,"size":_vm.size,"showSizeChanger":"","showQuickJumper":""},on:{"change":_vm.onChange,"showSizeChange":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }